import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Image from "../../Components/Reusable/Image";
import { handleApiErrors, validationRegex } from "../../Utils/Utils";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import AuthLayout from "../../Components/Layouts/Authlayout";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import SubmitButton from "../../Components/Reusable/Buttons";
import { SubTitleLabel, TitleLabel } from "../../Components/Reusable/LabelComponents";
import RoutesPath from "../../Utils/RoutesPath";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { OtpVerificationType } from "../../Utils/Enums";
import { RotatingLines } from "react-loader-spinner";
const ForgotPassword = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    email: validationRegex.email,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true)
    const { email } = data;
    try {
      const response = await StudentDashboardServices.forgotPassword(email);
      // toast.success(`OTP Sent Successfully!`);
      const otpParams = {
        email: email,
        type: OtpVerificationType.forgotPassword
      }
      navigate(RoutesPath.otpVerify, { state: otpParams });
    } catch (error) {
      setLoading(false);
      handleApiErrors(error);
    }
  };

  return (
    <AuthLayout>
      <div className="col-md-7 m-auto login_box">
        <div className="d-flex justify-content-center login_logo">
          <Image src={SvgImages.logo} className="img-fluid" alt="Logo" style={{ height: "70px" }} />
        </div>
        <div className="mb-4 text-center">
          <TitleLabel text={"Forgot your password?"} />
          <SubTitleLabel text={"Enter your email and we’ll send you a link to reset your password."} />
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <CustomTextFieldTwo
            labelTitle="Email Id"
            additionalClasses="profile_input"
            icon={SvgImages.email}
            id="email"
            name="email"
            placeholder="Enter your email id"
            showError={errors?.email}
            errorMessage={errors?.email?.message}
            register={register}
          />

          {loading ? (
            <div className="text-center d-flex justify-content-center">
              <RotatingLines
                height="25"
                width="25"
                strokeColor="#F6821F"      
              />
            </div>
          ) : (
            <SubmitButtonTwo title={"Continue"} className="mt-4 w-100 fw-700" />
          )}
        </form>

        <Link to={RoutesPath.login} className="back_login">
          <Image src={SvgImages.back_arrow_login} alt="Back" />
          Back to login
        </Link>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;



